const country = [
        {
          label: '美国',
          value: 'USA'
        },
        {
          label: '加拿大',
          value: 'CAN'
        },
        {
          label: '澳大利亚',
          value: 'AUS'
        },
        {
          label: '英国',
          value: 'GBR'
        },
        {
          label: '日本',
          value: 'JPN'
        },
        {
          label: '韩国',
          value: 'KOR'
        },
        {
          label: '中国',
          value: 'CN'
        },
        {
          label: '印度尼西亚',
          value: 'INA'
        },
        {
          label: '哈萨克斯坦',
          value: 'KAZ'
        },
        {
          label: '马来西亚',
          value: 'MYS'
        },
        {
          label: '菲律宾',
          value: 'PHL'
        },
        {
          label: '泰国',
          value: 'THA'
        },
        {
          label: '越南',
          value: 'VNM'
        },
        {
          label: '新加坡',
          value: 'SGP'
        },
        {
          label: '缅甸',
          value: 'MMR'
        },
        {
          label: '柬埔寨',
          value: 'KHM'
        },
        {
          label: '老挝',
          value: 'LAO'
        },
        {
          label: '孟加拉国',
          value: 'BGD'
        },
        {
          label: '斯里兰卡',
          value: 'LKA'
        },
        {
          label: '巴基斯坦',
          value: 'PAK'
        },
        {
          label: '尼泊尔',
          value: 'NPL'
        },
        {
          label: '阿联酋',
          value: 'ARE'
        },
        {
          label: '沙特阿拉伯',
          value: 'SAU'
        },
        {
          label: '科威特',
          value: 'KWT'
        },
        {
          label: '卡塔尔',
          value: 'QAT'
        },
        {
          label: '阿曼',
          value: 'OMN'
        },
        {
          label: '巴林',
          value: 'BHR'
        },
        {
          label: '伊拉克',
          value: 'IRQ'
        },
        {
          label: '约旦',
          value: 'JOR'
        },
        {
          label: '黎巴嫩',
          value: 'LBN'
        },
        {
          label: '叙利亚',
          value: 'SYR'
        },
        {
          label: '埃及',
          value: 'EGY'
        },
        {
          label: '摩洛哥',
          value: 'MAR'
        },
        {
          label: '突尼斯',
          value: 'TUN'
        },
        {
          label: '阿尔及利亚',
          value: 'DZA'
        },
        {
          label: '利比亚',
          value: 'LBY'
        },
        {
          label: '塞浦路斯',
          value: 'CYP'
        },
        {
          label: '以色列',
          value: 'ISR'
        },
        {
          label: '土耳其',
          value: 'TUR'
        },
        {
          label: '格鲁吉亚',
          value: 'GEO'
        },
        {
          label: '亚美尼亚',
          value: 'ARM'
        },
        {
          label: '阿塞拜疆',
          value: 'AZE'
        },
        {
          label: '乌兹别克斯坦',
          value: 'UZB'
        },
        {
          label: '吉尔吉斯斯坦',
          value: 'KGZ'
        },
        {
          label: '塔吉克斯坦',
          value: 'TJK'
        },
        {
          label: '土库曼斯坦',
          value: 'TKM'
        },
        {
          label: '俄罗斯',
          value: 'RUS'
        },
        {
          label: '白俄罗斯',
          value: 'BLR'
        },
        {
          label: '乌克兰',
          value: 'UKR'
        },
        {
          label: '摩尔多瓦',
          value: 'MDA'
        },
        {
          label:'香港',
          value:'HKG'
        }
      ]
const currency = [
        {
          label: '美元',
          value: 'USD'
        },
        {
          label: '欧元',
          value: 'EUR'
        },
        {
          label: '英镑',
          value: 'GBP'
        },
        {
          label: '日元',
          value: 'JPY'
        },
        {
          label: '韩元',
          value: 'KRW'
        },
        {
          label: '澳大利亚元',
          value: 'AUD'
        },
        {
          label: '加拿大元',
          value: 'CAD'
        },
        {
          label: '人民币',
          value: 'CNY'
        },
        {
          label: '印尼盾',
          value: 'IDR'
        },
        {
          label: '哈萨克斯坦坚戈',
          value: 'KZT'
        },
        {
          label: '马来西亚林吉特',
          value: 'MYR'
        },
        {
          label: '菲律宾比索',
          value: 'PHP'
        },
        {
          label: '泰铢',
          value: 'THB'
        },
        {
          label: '越南盾',
          value: 'VND'
        },
        {
          label: '新加坡元',
          value: 'SGD'
        },
        {
          label: '缅甸元',
          value: 'MMK'
        },
        {
          label: '柬埔寨瑞尔',
          value: 'KHR'
        },
        {
          label: '老挝基普',
          value: 'LAK'
        },
        {
          label: '孟加拉塔卡',
          value: 'BDT'
        },
        {
          label: '斯里兰卡卢比',
          value: 'LKR'
        },
        {
          label: '巴基斯坦卢比',
          value: 'PKR'
        },
        {
          label: '尼泊尔卢比',
          value: 'NPR'
        },
        {
          label: '阿联酋迪拉姆',
          value: 'AED'
        },
        {
          label: '沙特里亚尔',
          value: 'SAR'
        },
        {
          label: '科威特第纳尔',
          value: 'KWD'
        },
        {
          label: '卡塔尔里亚尔',
          value: 'QAR'
        },
        {
          label: '阿曼里亚尔',
          value: 'OMR'
        },
        {
          label: '巴林第纳尔',
          value: 'BHD'
        },
        {
          label: '伊拉克第纳尔',
          value: 'IQD'
        },
        {
          label: '约旦第纳尔',
          value: 'JOD'
        },
        {
          label: '黎巴嫩镑',
          value: 'LBP'
        },
        {
          label: '叙利亚镑',
          value: 'SYP'
        },
        {
          label: '埃及镑',
          value: 'EGP'
        },
        {
          label: '摩洛哥迪拉姆',
          value: 'MAD'
        },
        {
          label: '突尼斯第纳尔',
          value: 'TND'
        },
        {
          label: '阿尔及利亚第纳尔',
          value: 'DZD'
        },
        {
          label: '利比亚第纳尔',
          value: 'LYD'
        },
        {
          label: '塞浦路斯镑',
          value: 'CYP'
        },
        {
          label: '以色列谢克尔',
          value: 'ILS'
        },
        {
          label: '土耳其里拉',
          value: 'TRY'
        },
        {
          label: '格鲁吉亚拉里',
          value: 'GEL'
        },
        {
          label: '亚美尼亚德拉姆',
          value: 'AMD'
        },
        {
          label: '阿塞拜疆马纳特',
          value: 'AZN'
        },
        {
          label: '乌兹别克斯坦苏姆',
          value: 'UZS'
        },
        {
          label: '吉尔吉斯斯坦索姆',
          value: 'KGS'
        },
        {
          label: '塔吉克斯坦索莫尼',
          value: 'TJS'
        },
        {
          label: '土库曼斯坦马纳特',
          value: 'TMT'
        },
        {
          label: '俄罗斯卢布',
          value: 'RUB'
        },
        {
          label: '白俄罗斯卢布',
          value: 'BYN'
        },
        {
          label: '乌克兰格里夫纳',
          value: 'UAH'
        },
        {
          label: '摩尔多瓦列伊',
          value: 'MDL'
        },
        {
          label:'港币',
          value:'HKD'
        }
      ]
export default {
    country,
    currency
}